module.exports = __webpack_public_path__ + "img/default_header.c84897d2.png";